<template>
  <div
    class="d-flex justify-content-between align-items-center border-bottom cursor-pointer py-3 px-2"
    @click="handleClick"
  >
    <p class="body text-grey-900 m-0">{{ text }}</p>
    <ArrowRightIcon v-if="displayIcon" />
  </div>
</template>

<script lang="ts" setup>
  // Vue
  import { defineProps, defineEmits } from 'vue'
  // Icons
  import ArrowRightIcon from '@/assets/ArrowRightIcon.vue'

  // Props
  defineProps({
    text: {
      type: String,
      required: true,
    },
    displayIcon: {
      type: Boolean,
      default: true,
    },
  })

  // Emit
  const emit = defineEmits<{ (e: 'click'): void }>()

  // Methods
  const handleClick = (): void => {
    emit('click')
  }
</script>
